export enum Role {
  ADMIN = "ADMIN",
  CANDIDATE = "CANDIDATE",
  COMPANY = "COMPANY",
}
